// import React from 'react'

// const CreateWarehouse = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateWarehouse

import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs,
  IconButton,
  Link,
  Tooltip,
 
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";

import { SETTING_API_11, SETTING_API_14 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import { PageDataContext } from "../../utils/common/PageDataContext";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

function CreateWarehouse() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
    const location = useLocation();
  const { selectedItem } = location.state || {};
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [error, setError] = useState({});
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};


  const {   LOCCODE,STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
 
   const [selectedItemDetails, setSelectedItemDetails] = useState({
    paracode: "",
    minorderlevel: "",
    maxorderlevel: "",
    deliveryleadtime: "",
    minshortshelfperiod: "",
    itemexpnotifydays: "",
    minreordersize: "",
    openingstocklevel: "",
  });

useEffect(() => {
  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTING_API_14, "get", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        STS: CON_STATUS_ACTIVE,
        restcode: selectedItem.restcode
      });

      setData(result);

      // If result is an array and you want the first warehouse:
      if (Array.isArray(result) && result.length > 0) {
        setSelectedItemDetails({
          paracode: result[0].paracode || "",
          minorderlevel: result[0].minorderlevel || "",
          maxorderlevel: result[0].maxorderlevel || "",
          deliveryleadtime: result[0].deliveryleadtime || "",
          minshortshelfperiod: result[0].minshortshelfperiod || "",
          itemexpnotifydays: result[0].itemexpnotifydays || "",
          minreordersize: result[0].minreordersize || "",
          openingstocklevel: result[0].openingstocklevel || "",
        });
      }
      // If result is a single object:
      // else if (result && typeof result === "object") {
      //   setSelectedItemDetails({
      //     paracode: result.paracode || "",
      //     minorderlevel: result.minorderlevel || "",
      //     maxorderlevel: result.maxorderlevel || "",
      //     deliveryleadtime: result.deliveryleadtime || "",
      //     minshortshelfperiod: result.minshortshelfperiod || "",
      //     itemexpnotifydays: result.itemexpnotifydays || "",
      //     minreordersize: result.minreordersize || "",
      //     openingstocklevel: result.openingstocklevel || "",
      //   });
      // }

      console.log("result", result);

    } catch (err) {
      setError(err);
    }
  };

  fetchData();
}, []);

   const handlenumInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
    // Validate numeric input (allow integers and floats)
    const isNumeric = /^[0-9]*\.?[0-9]*$/.test(value); // Regular expression to allow numbers with optional decimal points
    if (!isNumeric) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input must contain only numbers or decimals.",
      }));
      return; // Prevent state update if input is not numeric
    }
  
    // Clear the value if it is "0" when focused
    if (value === "0") {
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: "",
      }));
      return;
    }
  
    // Clear error if input is valid
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setSelectedItemDetails({
      paracode: "",
    minorderlevel: "",
    maxorderlevel: "",
    deliveryleadtime: "",
    minshortshelfperiod: "",
    itemexpnotifydays: "",
    minreordersize: "",
    openingstocklevel: "",
    });

  };

   useEffect(() => {
      setPageData({
        title: "Warehouse Parameter",
        // icon: <HomeIcon />,
        // showBackButton: false,
        // customActions: <button>Refresh</button>,
        // breadcrumbs: ["Home", "Dashboard"],
      });
    }, []);

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
  

    const requiredFields = [
  
    { name: "minorderlevel", value: selectedItemDetails.minorderlevel, label: "Min Order Level" },
      { name: "maxorderlevel", value: selectedItemDetails.maxorderlevel, label: "Max Order Level" },
      { name: "deliveryleadtime", value: selectedItemDetails.deliveryleadtime, label: "Delivery Lead Time" },
      { name: "minshortshelfperiod", value: selectedItemDetails.minshortshelfperiod, label: "Minimum Short Shelf Period" },
      { name: "itemexpnotifydays", value: selectedItemDetails.itemexpnotifydays, label: "Item Expiry Notify Days" },
      { name: "minreordersize", value: selectedItemDetails.minreordersize, label: "Min Reorder Size" },
      { name: "openingstocklevel", value: selectedItemDetails.openingstocklevel, label: "Opening Stock Level" },
    ];

 const missingRequiredFields = requiredFields.filter(
  (field) => field.value === null || field.value === undefined || field.value.toString().trim() === ""
);

    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

    // if (data) {
    //   const isDuplicate = data.some((item) => {
    //     if (
    //       item.paracode !==  selectedItemDetails.paracode &&
    //       item.industryname.toLowerCase() === industryname.toLowerCase()
    //     ) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });

    //   if (isDuplicate) {
    //     setAlertMessage("Industry Already Exists.");
    //     setAlertType("warning");

    //     setAlertOpen(true); // Open the alert
    //     return;
    //   }
    // }



    const staticValues = {
      COMPCODE,
        LOCCODE:STAFFMAPLOCODE,


      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
       restcode: selectedItem.restcode,
      paracode: selectedItemDetails.paracode || "" , // Use existing paracode or generate a new one
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTING_API_14, payload);
      console.log("Success:", responseData);
      setAlertMessage(
         "Updated Successfully!" 
      );
      setAlertType("success");

      setAlertOpen(true);
    //  handleClear(); // Clear the form after successful submission
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
    setTimeout(() => {
      navigate("/vwarehouseparameters");
    }, 2000);
  };
 

  const addToView = () => {
    navigate("/vwarehouseparameters");
  }

  return (
    <>
       <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to Warehouse Parameters " arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
        onClick={addToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip> 
     <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
         Warehouse 
          </Link>
        </Breadcrumbs>
      </Box>

  <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}> { "Warehouse Parameter "}</Typography>
            </Grid>
          </Grid>
        </AppBar>
 <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
    <Grid container spacing={2} sx={styles.add_form_page_grid_container}>
  <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Max Order Level"
      name="maxorderlevel"
      value={selectedItemDetails.maxorderlevel}
      onChange={handlenumInputChange}
      fullWidth
      required
      size="small"
      variant="outlined"
      error={!!error.maxorderlevel}
      helperText={error.maxorderlevel}
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
   <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Min Order Level"
      name="minorderlevel"
      value={selectedItemDetails.minorderlevel}
    onChange={handlenumInputChange}
    required
      fullWidth
      size="small"
      variant="outlined"
      error={!!error.minorderlevel}
      helperText={error.minorderlevel}
    
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
 <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Delivery Lead Time"
      name="deliveryleadtime"
      value={selectedItemDetails.deliveryleadtime}
     onChange={handlenumInputChange}
      fullWidth
      size="small"
      required
      variant="outlined"
      error={!!error.deliveryleadtime}
      helperText={error.deliveryleadtime}
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
   <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Minimum Short Shelf Period"
      name="minshortshelfperiod"
      value={selectedItemDetails.minshortshelfperiod}
       onChange={handlenumInputChange}
      fullWidth
      required
      size="small"
      variant="outlined"
      error={!!error.minshortshelfperiod}
      helperText={error.minshortshelfperiod}
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
   <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Opening Stock Level"
      name="openingstocklevel"
      value={selectedItemDetails.openingstocklevel}
        onChange={handlenumInputChange}
      fullWidth
      required
      size="small"
      variant="outlined"
      error={!!error.openingstocklevel}
      helperText={error.openingstocklevel}
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
  
   <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Item Expiry Notify Days"
      name="itemexpnotifydays"
      value={selectedItemDetails.itemexpnotifydays}
        onChange={handlenumInputChange}
      fullWidth
      required
      size="small"
      variant="outlined"
      error={!!error.itemexpnotifydays}
      helperText={error.itemexpnotifydays}
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
  
   <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
    <TextField
      label="Min Reorder Size"
      name="minreordersize"
      value={selectedItemDetails.minreordersize}
        onChange={handlenumInputChange}
      fullWidth
      required
      size="small"
      variant="outlined"
      error={!!error.minreordersize}
      helperText={error.minreordersize}
      FormHelperTextProps={{ sx: { fontSize: "12px", color: "red" } }}
    />
  </Grid>
</Grid></Box>

        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleClear}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
          >
            Confirm
          </Button>
        </Box>
    </Box>


    

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
  
    </>
  );
}

export default CreateWarehouse;
